import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { GdsServiceProductStatus } from '@websky/graphql';
import { useTheme } from '../../../theme';
import Money from '../../../Money';
import { capitalizeFirstLetter } from '../../../utils';
import { isShowInsurancesByPassengers } from '../../utils';
import { CdnIcon } from '@shared/ui';
const ServiceSummaryGroup = ({ services, notification, mode = 'default', serviceType }) => {
    const { t } = useTranslation('Cart');
    const { ServiceSummaryOption: css } = useTheme('ServiceSummary');
    const isInsurancesByPassengersMode = serviceType === 'Insurance' && isShowInsurancesByPassengers(mode);
    return (React.createElement("div", { className: css.options },
        services.map((item, index) => {
            const isBooked = item.status === GdsServiceProductStatus.Booked;
            const isRequested = item.status === GdsServiceProductStatus.Requested;
            const showControls = item.downloadUrl || item.included;
            const price = isInsurancesByPassengersMode ? item.passengerPrice : item.price;
            return (React.createElement("div", { className: cn(css.option, {
                    [css.option_icon]: item.icon,
                    [css.option_booked]: isBooked,
                    [css.option_requested]: isRequested,
                    [css.option_rejected]: item.status === GdsServiceProductStatus.Rejected,
                    [css.option_canceled]: item.status === GdsServiceProductStatus.Canceled,
                    [css.option_problematic]: item.status === GdsServiceProductStatus.Problematic,
                    [css.option_included]: item.included
                }), key: index, "data-index": index },
                item.icon ? React.createElement("div", { className: css.option__icon }, item === null || item === void 0 ? void 0 : item.icon) : null,
                React.createElement("span", { className: css.option__name }, isInsurancesByPassengersMode ? capitalizeFirstLetter(item === null || item === void 0 ? void 0 : item.passengerName) : item === null || item === void 0 ? void 0 : item.name),
                item.description && React.createElement("span", { className: css.option__description }, item === null || item === void 0 ? void 0 : item.description),
                showControls && (React.createElement("div", { className: css.option__controls },
                    item.downloadUrl && (React.createElement("a", { className: css.option__download, href: '#', onClick: e => {
                            e.preventDefault();
                            const urls = isInsurancesByPassengersMode || serviceType !== 'Insurance'
                                ? [item.downloadUrl]
                                : item.allPassengersDownloadUrls;
                            urls === null || urls === void 0 ? void 0 : urls.forEach(url => window.open(url, '_blank'));
                        } },
                        React.createElement(CdnIcon, { icon: 'Action/Download' }))),
                    item.included && (React.createElement("div", { className: css.option__iconIncluded },
                        React.createElement(CdnIcon, { icon: 'Info/Item Icluded' }))))),
                price && !showControls && (React.createElement("div", { className: css.option__price },
                    React.createElement("div", { className: css.option__price_money },
                        item.priceFrom && t('Checkout:from'),
                        React.createElement(Money, { moneyClassName: css.option__money, money: price }),
                        !!item.onDelete && !isRequested && (React.createElement("div", { className: css.option__price_icon, onClick: item.onDelete },
                            React.createElement(CdnIcon, { icon: 'Action/Close-Clear' }))))))));
        }),
        notification));
};
export default ServiceSummaryGroup;
